import _0x1339fa from'./arrayLikeToArray.js';export default function _arrayWithoutHoles(_0x39c74b){if(Array['isArray'](_0x39c74b))return _0x1339fa(_0x39c74b);}